import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=fd55dff6&scoped=true"
var script = {}
import style0 from "./modules.vue?vue&type=style&index=0&id=fd55dff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd55dff6",
  null
  
)

export default component.exports